import React from 'react';
import { TextInput } from 'react-admin';

import { UiBaseInput } from './BaseInput';

export const UiInput = props => <UiBaseInput component={TextInput} {...props} />;
